import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, setTz } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Panel } from "@/components/common";
import { TextField, Field } from "@/components/Crud";

export default function AppSettings() {
  const { settings, setSettings } = useAuth();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (settings && !form) setForm(settings);
  }, [settings, form]);

  if (!form) return <p className="text-sm text-zinc-500">Memuat...</p>;
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.put("/settings", { ...form, tax_percent: Number(form.tax_percent), service_percent: Number(form.service_percent), tz_offset: Number(form.tz_offset) });
      setTz(r.data.tz_offset);
      setSettings(r.data);
      toast.success("Pengaturan disimpan");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <PageHeader title="Pengaturan Aplikasi" subtitle="Identitas usaha, pajak, service charge, dan struk" />
      <form onSubmit={save} className="max-w-2xl space-y-6" data-testid="app-settings-form">
        <Panel className="space-y-4 p-6">
          <h3 className="text-lg font-semibold">Identitas Usaha</h3>
          <TextField label="Nama Aplikasi / Usaha" testId="settings-app-name" required value={form.app_name} onChange={(e) => set("app_name", e.target.value)} />
          <TextField label="Alamat" testId="settings-address" value={form.address} onChange={(e) => set("address", e.target.value)} />
          <TextField label="No. Telepon" testId="settings-phone" value={form.phone} onChange={(e) => set("phone", e.target.value)} />
        </Panel>
        <Panel className="grid grid-cols-1 gap-4 p-6 sm:grid-cols-3">
          <h3 className="text-lg font-semibold sm:col-span-3">Tagihan</h3>
          <TextField label="Service Charge (%)" testId="settings-service" type="number" step="0.1" min="0" max="100" value={form.service_percent} onChange={(e) => set("service_percent", e.target.value)} />
          <TextField label="Pajak / PPN (%)" testId="settings-tax" type="number" step="0.1" min="0" max="100" value={form.tax_percent} onChange={(e) => set("tax_percent", e.target.value)} />
          <TextField label="Zona Waktu (UTC+)" testId="settings-tz" type="number" min="-12" max="14" value={form.tz_offset} onChange={(e) => set("tz_offset", e.target.value)} />
          <p className="text-xs text-zinc-500 sm:col-span-3">Pajak dihitung dari subtotal + service. Zona waktu dipakai untuk laporan harian (WIB = 7, WITA = 8, WIT = 9).</p>
        </Panel>
        <Panel className="space-y-4 p-6">
          <h3 className="text-lg font-semibold">Struk</h3>
          <Field label="Catatan kaki struk"><Textarea data-testid="settings-footer" value={form.receipt_footer} onChange={(e) => set("receipt_footer", e.target.value)} rows={2} /></Field>
        </Panel>
        <Button data-testid="settings-save-btn" type="submit" disabled={busy} className="rounded-xl bg-orange-600 px-8 hover:bg-orange-700">{busy ? "Menyimpan..." : "Simpan Pengaturan"}</Button>
      </form>
    </div>
  );
}
